<template>
    <div>

        <!-- Exibe o token -->
        <div :class="isInputError('token')" @click="removeError('token')">
            <strong class="title-medium mt-4">API Key</strong>
            <b-form-group id="fieldset-token" label-for="input-token">
                <b-form-input id="input-token" placeholder="Informe o API Key do Enotas" class="form-input"
                    v-model="token" :disabled="loading" trim></b-form-input>
            </b-form-group>
            <span class="show-error">
                {{ showError('token') }}
            </span>
        </div>

        <!-- Botao Salvar -->
        <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
            <template v-if="loadingSave">
                <b-spinner variant="light" class="mr-2" small></b-spinner>
                {{ $t('views.seller.integrations.config.save.button.saving') }}
            </template>
            <template v-else>
                {{ $t('views.seller.integrations.config.save.button.save') }}
            </template>
        </b-button>

    </div>
</template>

<script>

import Vue from 'vue';
import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";

export default {
    name: "IntegrationsConfigEnotas",
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        integration: {
            type: Object,
            required: true,
            default: () => ({ name: 'Enotas' })
        },
        mountInputError: {
            type: Function,
            required: true
        },
        isInputError: {
            type: Function,
            required: true
        },
        removeError: {
            type: Function,
            required: true
        },
        showError: {
            type: Function,
            required: true
        },
        fetchCallbacks: {
            type: Function,
            required: true
        },
    },
    data: () => {
        return {
            token: '',
            loadingSave: false,
        }
    },
    methods: {
        resetForm() {
            this.token = '';
        },
        saveItegration() {
            this.loadingSave = true;

            // Busca para ver se existe config salva
            NoteCenterIntegration.build().search({
                url: '/search/name/Enotas',
                name: 'Enotas'
            })
                .then(response => {
                    if (response.config_integration) {
                        this.confirmUpdate();
                        return;
                    }

                    this.updateItegration();
                });
        },
        confirmUpdate() {
            Vue.swal({
                title: 'Integração já existente',
                html: `<p>Para substituir a integração atual, clique no botão abaixo.</p>`,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: this.$t('views.seller.integrations.config.alert.update.ok'),
                cancelButtonText: 'Cancelar',
                customClass: "sweet-container-new",
                confirmButtonClass: "btn btn-primary text-nowrap",
                cancelButtonClass: "btn btn-outline-secondary text-nowrap",
                buttonsStyling: false,
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.updateItegration();
                }
                else {
                    this.loadingSave = false;
                }
            });
        },
        updateItegration() {
            NoteCenterIntegration.build().post('', {
                name: 'Enotas',
                config_integration: {
                    token: this.token
                },
                token: this.token,
                default: false
            }, { suppressErrorNotify: true })
                .then(() => {
                    this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
                        title: this.$t('views.seller.integrations.config.toast.save.success.title'),
                        variant: "success",
                        autoHideDelay: 5000,
                        appendToast: true,
                    });

                    this.resetForm();
                    this.fetchCallbacks();
                })
                .catch(error => {
                    this.mountInputError({
                        "token": error.response.data.error || 'API Key inválida'
                    });
                    this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
                        title: this.$t('views.seller.integrations.config.toast.save.error.title'),
                        variant: "danger",
                        autoHideDelay: 5000,
                        appendToast: true,
                    })
                })
                .finally(() => {
                    this.loadingSave = false;
                });
        },
    }
}

</script>